import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import i18next, { t } from "i18next";
import MainButton from "../../common/buttons/mainButton/MainButton";
import Logo from "../../../assets/images/logo.webp";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const IntroModals = ({
  show,
  handleClose,
  backUrl,
  userData,
  isDataLoading,
}) => {
  // language data from store
  const Resource = useSelector((state) => state.translation.resource);
  return (
    <Modal
      show={show}
      onHide={() => {
        handleClose();
        localStorage.removeItem("intro-modal");
      }}
    >
      {backUrl === "1" ? (
        <Modal.Body>
          <Modal.Header closeButton></Modal.Header>
          <div className="modal-img">
            <img src={Logo} alt="logo" />
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="60"
            height="60"
            viewBox="0 0 100.543 100.543"
            className="mb-3"
          >
            <g
              id="Iconly_Light_Danger-Circle"
              data-name="Iconly/Light/Danger-Circle"
              transform="translate(-0.25 -0.25)"
            >
              <g id="Danger-Circle" transform="translate(2.75 2.75)">
                <path
                  id="Stroke-1"
                  d="M48.522.75A47.771,47.771,0,1,1,.75,48.522,47.772,47.772,0,0,1,48.522.75Z"
                  transform="translate(-0.75 -0.75)"
                  fill="none"
                  stroke="#90359c"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  stroke-width="5"
                  fill-rule="evenodd"
                />
                <line
                  id="Stroke-3"
                  y2="22.822"
                  transform="translate(47.746 28.168)"
                  fill="none"
                  stroke="#90359c"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  stroke-width="5"
                />
                <line
                  id="Stroke-5"
                  x2="0.052"
                  transform="translate(47.745 67.376)"
                  fill="none"
                  stroke="#90359c"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  stroke-width="5"
                />
              </g>
            </g>
          </svg>
          <div className="title">
            {Resource?.dont_register_yet
              ? Resource?.dont_register_yet
              : t("dont_register_yet")}
          </div>
          <div className="description">
            {Resource?.join_now_to_start
              ? Resource?.join_now_to_start
              : t("join_now_to_start")}
          </div>
          <Link to={`/courses`}>
            <MainButton
              buttonText={
                Resource?.browse_courses
                  ? Resource?.browse_courses
                  : t("home.header.browse_courses")
              }
              buttonClick={() => {
                localStorage.removeItem("intro-modal");
              }}
            />
          </Link>
        </Modal.Body>
      ) : backUrl === "2" ? (
        <Modal.Body>
          <Modal.Header closeButton></Modal.Header>
          <div className="modal-img">
            <img src={Logo} alt="logo" />
          </div>
          <div className="title">
            {Resource?.welcome_to_darebni_family
              ? Resource?.welcome_to_darebni_family
              : t("welcome_to_darebni_family")}
          </div>
          <div className="description">
            {Resource?.tell_you_about_accept
              ? Resource?.tell_you_about_accept
              : t("tell_you_about_accept")}{" "}
            <br />
            {Resource?.please_complete_payment
              ? Resource?.please_complete_payment
              : t("please_complete_payment")}
          </div>
          <Link to={`/payment`}>
            <MainButton
              buttonText={
                Resource?.complete_payment
                  ? Resource?.complete_payment
                  : t("complete_payment")
              }
              buttonClick={() => {
                localStorage.removeItem("intro-modal");
              }}
            />
          </Link>
        </Modal.Body>
      ) : backUrl === "3" ? (
        <Modal.Body>
          <Modal.Header closeButton></Modal.Header>
          <div className="modal-img">
            <img src={Logo} alt="logo" />
          </div>
          <div className="title">
            {Resource?.sorry_about_reject
              ? Resource?.sorry_about_reject
              : t("sorry_about_reject")}
            <br />
            {Resource?.wish_see_you_next
              ? Resource?.wish_see_you_next
              : t("wish_see_you_next")}
          </div>
          <div className="description">
            {Resource?.remember ? Resource?.remember : t("remember")}
          </div>
          <Link to={`/courses`}>
            <MainButton
              buttonText={
                Resource?.start_learn_journy
                  ? Resource?.start_learn_journy
                  : t("start_learn_journy")
              }
              buttonClick={() => {
                localStorage.removeItem("intro-modal");
              }}
            />
          </Link>
        </Modal.Body>
      ) : (
        backUrl === "4" && (
          <Modal.Body>
            <Modal.Header closeButton></Modal.Header>
            <div className="modal-img">
              <img src={Logo} alt="logo" />
            </div>
            <div className="title">
              {Resource?.hello ? Resource?.hello : t("hello")}{" "}
              {isDataLoading ? (
                <Spinner size="md" />
              ) : i18next.language === "ar" ? (
                <>
                  {userData?.student?.first_name}&nbsp;
                  {userData?.student?.last_name}
                </>
              ) : (
                <>
                  {userData?.student?.first_name_en}&nbsp;
                  {userData?.student?.last_name_en}
                </>
              )}
              <br />
              {Resource?.welcome_to_darebni_family
                ? Resource?.welcome_to_darebni_family
                : t("welcome_to_darebni_family")}
            </div>
            <div className="description">
              {Resource?.serf_website
                ? Resource?.serf_website
                : t("serf_website")}
            </div>
            <Link to={`/courses`}>
              <MainButton
                buttonText={
                  Resource?.browse_courses
                    ? Resource?.browse_courses
                    : t("home.header.browse_courses")
                }
                buttonClick={() => {
                  localStorage.removeItem("intro-modal");
                }}
              />
            </Link>
          </Modal.Body>
        )
      )}
    </Modal>
  );
};

export default IntroModals;
